import { render, staticRenderFns } from "./SharedResourcePage.vue?vue&type=template&id=ba3b5bf4"
import script from "./SharedResourcePage.vue?vue&type=script&lang=js"
export * from "./SharedResourcePage.vue?vue&type=script&lang=js"
import style0 from "./SharedResourcePage.vue?vue&type=style&index=0&id=ba3b5bf4&prod&deep=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports